module.exports = __webpack_public_path__ + "img/家庭作业.c8b21a0a.png";